/**
 * Constants for Question Coach
 */

/**
 * Margin/Threshold constraints for over/under questions
 */
export const MARGIN_CONSTRAINTS = {
  MIN: 0.1,
  STEP: 0.5,
  PLACEHOLDER: 'e.g., 300 or 27.5',
} as const;

/**
 * Minimum team requirements for different question types
 */
export const MIN_TEAMS = {
  OVER_UNDER: 1,
  SELECTION: 2,
} as const;

/**
 * Over/Under comparison types
 */
export enum OverUnderComparison {
  OVER = 'over',
  UNDER = 'under',
}

/**
 * Batch question creation (DKPLAT-501 Phase 1): show a soft warning in the review
 * step when the planned batch is larger than this, but never hard-block creation.
 */
export const BATCH_QUESTION_WARNING_THRESHOLD = 20;
